import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {

  private subscription: Subscription = null;

  constructor(
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.subscription = this.router.events.subscribe(event => {
      // Scroll page to top if route changed
      if (event instanceof NavigationEnd && window) {
        window.scrollTo(0, 0);
      }
    });
    let token = localStorage.getItem('token');
    let location = window.location;
    let href = location.href;
    if (!token && !(/\/authenticate/gi).test(href) && !(/\/template/gi).test(href)) {
      let navigationExtras: NavigationExtras = {
          queryParams: {
              urlb: href
          }
      };
      this.router.navigate(['/authenticate'], navigationExtras);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts